export default __webpack_public_path__ + "static/media/mosquitera-enrollable-card.b9268e5f.jpg";